"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));
var _propTypes = require("prop-types");
var _excluded = ["rows", "rowHeight"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ParagraphPlaceholder = function ParagraphPlaceholder(_ref) {
  var rows = _ref.rows,
    rowHeight = _ref.rowHeight,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var placeholderRows = [];
  for (var i = 0; i < rows; i += 1) {
    placeholderRows.push( /*#__PURE__*/_react["default"].createElement("rect", {
      width: "100%",
      height: rowHeight,
      key: "placeholder-row".concat(i)
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_reactContentLoader["default"], _extends({
    viewBox: "0 0 100% ".concat(rowHeight),
    style: {
      height: rowHeight,
      width: '100%'
    }
  }, otherProps), placeholderRows);
};
ParagraphPlaceholder.defaultProps = {
  rows: 1,
  rowHeight: 12
};
ParagraphPlaceholder.propTypes = {
  rows: _propTypes.PropTypes.number,
  rowHeight: _propTypes.PropTypes.number
};
ParagraphPlaceholder.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ParagraphPlaceholder",
  "props": {
    "rows": {
      "defaultValue": {
        "value": "1",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "rowHeight": {
      "defaultValue": {
        "value": "12",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    }
  }
};
var _default = ParagraphPlaceholder;
exports["default"] = _default;